var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "1 2 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9042 4C8.64452 4 5.68925 5.92193 3.67999 9.0803C3.2098 9.81721 3 10.7543 3 11.6458C3 12.5372 3.20971 13.474 3.67968 14.2109C5.68894 17.3695 8.64435 19.2917 11.9042 19.2917C15.1638 19.2917 18.1191 17.3697 20.1283 14.2114C20.5985 13.4745 20.8083 12.5374 20.8083 11.6458C20.8083 10.7545 20.5986 9.81762 20.1287 9.08079C18.1194 5.92213 15.164 4 11.9042 4ZM4.94532 9.88588C6.75273 7.04453 9.28065 5.5 11.9042 5.5C14.5277 5.5 17.0556 7.04453 18.863 9.88588L18.8636 9.88686C19.1432 10.3249 19.3083 10.9626 19.3083 11.6458C19.3083 12.3291 19.1432 12.9668 18.8636 13.4048L18.863 13.4058C17.0556 16.2471 14.5277 17.7917 11.9042 17.7917C9.28065 17.7917 6.75273 16.2471 4.94532 13.4058L4.94469 13.4048C4.66511 12.9668 4.5 12.3291 4.5 11.6458C4.5 10.9626 4.66511 10.3249 4.94469 9.88686L4.94532 9.88588ZM9.5 11.7333C9.5 10.4975 10.4975 9.5 11.7333 9.5C12.9691 9.5 13.9667 10.4975 13.9667 11.7333C13.9667 12.9691 12.9691 13.9667 11.7333 13.9667C10.4975 13.9667 9.5 12.9691 9.5 11.7333ZM11.7333 8C9.66912 8 8 9.66912 8 11.7333C8 13.7975 9.66912 15.4667 11.7333 15.4667C13.7975 15.4667 15.4667 13.7975 15.4667 11.7333C15.4667 9.66912 13.7975 8 11.7333 8Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowEye);
export default __webpack_public_path__ + "static/media/showEye.9ac3655c84494fd63deb1e85d40f6c02.svg";
export { ForwardRef as ReactComponent };